import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Tab, Nav, Form, Button, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import {
  faUser,
  faCreditCard,
  faFileInvoice,
} from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./AdminDashboard.css";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import MyContext from "../../MyContext";

const ProfileSection = ({ Admin }) => {
  const {baseUrl, config} = useContext(MyContext);
  const { id } = useParams();
  
  const [startDate, setStartDate] = useState(new Date());
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [User, setUser] = useState({});
  const [Clients, setClients] = useState([]);
  const [credentials, setCredentials] = useState({})
  const [Loading, setLoading] = useState(false);
  const [Lerror, setLerror] = useState(null);
  const [error, setError] = useState(null);

  // Profile Section States
  const [formDataProfile, setFormDataProfile] = useState({
    client_name: "",
    client_mobile: "",
    billing_name: "",
    first_name: "",
    last_name: "",
    activated_on: "",
    allowed_ip: "",
    exprired_on: "",
    client_mobile: "",
    status: "",
client_email:"",
whitelistedAt:"",
    id:"",
   
  });

  // Billing Section States
  const [formData, setFormData] = useState({
    server_charges: "",
    monthly_reccuring_charges: "",
    other_charges: "",
    chats_count: "",
    submissionPercentage:"",
    live_chat_charges: "",
    account_type: "",
    received_amount: "",
    email_alert_limit: "",
    min_balance_limit: "",
    billed_on: "",
    gst: "",
    customer_id: "",
    billing_type: "",
    marketing_pin: "",
    utility_pin: "",
    authentication_pin: "",
    service_pin: "",
    feedback_pin: "",
    response_pin: "",
    remarks: "",
  });

  useEffect(() => {
    if (credentials) {
      setFormData({
        server_charges: credentials.server_charges || "",
        monthly_reccuring_charges: credentials.monthly_reccuring_charges || "",
        other_charges: credentials.other_charges || "",
        chats_count: credentials.chats_count || "",
        submissionPercentage:credentials.submissionPercentage||"",
        live_chat_charges: credentials.live_chat_charges || "",
        account_type: credentials.account_type || "",
        received_amount: credentials.received_amount || "",
        email_alert_limit: credentials.email_alert_limit || "",
        min_balance_limit: credentials.min_balance_limit || "",
        billed_on: credentials.billed_on || "",
        gst: credentials.gst || "",
        customer_id: credentials.customer_id || "",
        billing_type: credentials.billing_type || "",
        marketing_pin: credentials.marketing_pin || "",
        utility_pin: credentials.utility_pin || "",
        authentication_pin: credentials.authentication_pin || "",
        service_pin: credentials.service_pin || "",
        feedback_pin: credentials.feedback_pin || "",
        response_pin: credentials.response_pin || "",
        remarks: credentials.remarks || "",
      });
    }
  }, [credentials]);
  useEffect(() => {
    if (User) {
      setFormDataProfile({
        client_name: User.client_name || "",
        client_mobile: User.client_mobile || "",
        billing_name: User.billing_name || "",
        first_name: User.first_name || "",
        last_name: User.last_name || "",
        activated_on: formatDateForInput(User.activated_on) || "",
        allowed_ip: User.allowed_ip || "",
        exprired_on: formatDateForInput(User.exprired_on) || "",
        status: User.status || "",
        id: User.id || "",
        whitelistedAt:User.whitelistedAt||"",
      });
    }
  }, [User]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  
  const handleChangeProfile = (e) => {
    const { name, value } = e.target;
    setFormDataProfile({ ...formData, [name]: value });
  };

  // fetch SuperAdmin Client Api call
  const FetchSuperAdminClientsCall = async () => {
    setLoading(true);
    try {
      const UserDetail = {
        // userid: User.pkid,
        userid: Admin.pkid,
        latitude: latitude,
        longitude: longitude,
      };

      const response = await axios.post(
        ` ${baseUrl}/api/SuperAdmin/getClientList`,
        UserDetail,
        config
      );
      if (response.data.responseCode === "00") {
        // toast.success(response.data.responseMessage);
        setClients(response.data.response);
        setLoading(false);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("error");
      console.error("Error updating Admin login:", error);
    } finally {
      setLoading(false);
    }
  };
    // fetch SuperAdmin Client Api call
    const FetchClientCredentials = async () => {
      setLoading(true);
      try {
        const UserDetail = {
          // userid: User.pkid,
          userid: id,
          latitude: latitude,
          longitude: longitude,
        };
  
        const response = await axios.post(
          ` ${baseUrl}/api/SuperAdmin/getClientConfigurations`,
          UserDetail,
          config
        );
        if (response.data.responseCode === "00") {
          // toast.success(response.data.responseMessage);
  
          setCredentials(response.data.response);
          setLoading(false);
        } else {
          toast.error(response.data.responseMessage);
        }
      } catch (error) {
        toast.error("error");
        console.error("Error updating Admin login:", error);
      } finally {
        setLoading(false);
      }
    };
    // Edit Client credential call

    const EditClientsCredentialCall = async (e) => {
      e.preventDefault();
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to change the Credentials ?",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, accept it!",
      }).then(async (result) => { 
        if (result.isConfirmed) {
          try {
            const UserDetail = {
              userid: Admin.pkid, 
              clientId: id,
              serverCharges: formData.server_charges,
              monthlyReccuringCharges: formData.monthly_reccuring_charges,
              otherCharges: formData.other_charges,
              chatsCount: formData.chats_count,
              submissionPercentage: formData.submissionPercentage,
              liveChatCharges: formData.live_chat_charges,
              accountType: formData.account_type,
              receivedAmount: formData.received_amount,
              emailAlertLimit: formData.email_alert_limit,
              minBalanceLimit: formData.min_balance_limit,
              billedOn: formData.billed_on,
              gst: formData.gst,
              customerId: formData.customer_id,
              billingType: formData.billing_type,
              marketingPin: formData.marketing_pin,
              utilityPin: formData.utility_pin,
              authenticationPin: formData.authentication_pin,
              servicePin: formData.service_pin,
              feedbackPin: formData.feedback_pin,
              responsePin: formData.response_pin,
              remarks: formData.remarks,
            };
      
            const response = await axios.post(
              ` ${baseUrl}/api/SuperAdmin/editClientConfigurations`,
              UserDetail,
              config
            );
            if (response.data.responseCode === "00") {
              // toast.success(response.data.responseMessage);
              setClients(response.data.response);
              setLoading(false);
            } else {
              toast.error(response.data.responseMessage);
            }
          } catch (error) {
            toast.error("error");
            console.error("Error updating Admin login:", error);
            Swal.fire("Error!", "Something went wrong.", "error");
          } finally {
            setLoading(false);
          }
        }
      });
    };
        // Edit Client credential call

        const EditClientsDetailsCall = async (e) => {
          e.preventDefault();
          Swal.fire({
            title: "Are you sure?",
            text: "Do you want to change the User Details?",
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, accept it!",
          }).then(async (result) => { // Make this function async
            if (result.isConfirmed) {
              try {
                const UserDetail = {
                  userid: formDataProfile.id, 
                  clientId: formDataProfile.client_name, 
                  firstName: formDataProfile.first_name, 
                  lastName: formDataProfile.last_name, 
                  emailId: formDataProfile.client_email, 
                  mobileNumber: formDataProfile.client_mobile, 
                  billingName: formDataProfile.billing_name, 
                  expiredOn: formDataProfile.exprired_on, 
                  allowedIp: formDataProfile.allowed_ip,
                };
          
                const response = await axios.post(
                  ` ${baseUrl}/api/SuperAdmin/editClientDetails`,
                  UserDetail,
                  config
                );
                if (response.data.responseCode === "00") {
                  // toast.success(response.data.responseMessage);
                  setClients(response.data.response);
                  setLoading(false);
                } else {
                  toast.error(response.data.responseMessage);
                }
              } catch (error) {
                toast.error("error");
                console.error("Error updating Admin login:", error);
                Swal.fire("Error!", "Something went wrong.", "error");
              } finally {
                setLoading(false);
              }
            }
          });
        };

  useEffect(() => {
    // Check if the Geolocation API is available
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Update latitude and longitude states
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (err) => {
          setLerror(err.message);
        }
      );
    } else {
      setError("Geolocation is not supported by your browser");
    }
    // FetchClientCall();
    FetchSuperAdminClientsCall();
  }, []);
  useEffect(() => {
  FetchClientCredentials();
  }, [id])
  
  useEffect(() => {
    if(Clients && Clients.length >0){
      Clients?.map((user , index)=>{
        user?.id ===id ? setUser(user):console.error("Can't user get Credentials!")
      })
    }

  }, [Clients])

  
  // Function to convert API date (M/D/YYYY hh:mm:ss A) to YYYY-MM-DD
  const formatDateForInput = (apiDate) => {
    if (!apiDate) return "";
    const dateObj = new Date(apiDate);
    return dateObj.toISOString().split("T")[0]; // Extract YYYY-MM-DD
  };
  

  

  return (
    <div className="p-4 profile-section marginRight">
      <ToastContainer/>
      <h2 className="profile-heading">
        <FontAwesomeIcon icon={faUser} className="me-2" />
        User Profile
      </h2>
      <h3 className="user-name">{User.client_name}</h3>
      <hr className="profile-divider" />

      <Tab.Container defaultActiveKey="profile">
        <Nav variant="tabs" className="profile-tabs">
          <Nav.Item>
            <Nav.Link eventKey="profile">
              <FontAwesomeIcon icon={faUser} className="me-2" />
              Profile
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="billing">
              <FontAwesomeIcon icon={faCreditCard} className="me-2" />
              Billing
            </Nav.Link>
          </Nav.Item>
          {/* <Nav.Item>
            <Nav.Link eventKey="installment">
              <FontAwesomeIcon icon={faFileInvoice} className="me-2" />
              Installment
            </Nav.Link>
          </Nav.Item> */}
        </Nav>

        <Tab.Content className="tab-content-section">
          <Tab.Pane eventKey="profile">
            <Form className="profile-form" onSubmit={EditClientsDetailsCall}>
              <div>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>User Role</Form.Label>
                    <Form.Select>
                      <option value="">Select Role</option>
                      <option value="admin">Administrator</option>
                      <option value="manager">Manager</option>
                      <option value="user">User</option>
                      <option value="guest">Guest</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Username</Form.Label>
                    <Form.Control type="text" placeholder="Enter username" value={formDataProfile.client_name} onChange={handleChangeProfile} />
                  </Form.Group>
                </Col>
              </div>

              <div>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter password"
                      />
                      <Button
                        variant="link"
                        className="position-absolute end-0 top-50 translate-middle-y"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        <FontAwesomeIcon
                          icon={showPassword ? faEyeSlash : faEye}
                        />
                      </Button>
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Confirm Password</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Confirm password"
                      />
                      <Button
                        variant="link"
                        className="position-absolute end-0 top-50 translate-middle-y"
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                      >
                        <FontAwesomeIcon
                          icon={showConfirmPassword ? faEyeSlash : faEye}
                        />
                      </Button>
                    </div>
                  </Form.Group>
                </Col>
              </div>
              <hr className="profile-divider" />
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control type="text" placeholder="Enter first name" value={formDataProfile.first_name} onChange={handleChangeProfile}/>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control type="text" placeholder="Enter last name"value={formDataProfile.last_name}onChange={handleChangeProfile} />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter email address"
                      onChange={handleChangeProfile}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Mobile Number</Form.Label>
                    <Form.Control
                      type="tel"
                      placeholder="Enter mobile number"
                      value={formDataProfile.client_mobile}
                      onChange={handleChangeProfile}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Billing Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter billing name"
                      value={formDataProfile.billing_name}
                      onChange={handleChangeProfile}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Account Expiry On</Form.Label>
                    <Form.Control type="date" value={formDataProfile.exprired_on} onChange={handleChangeProfile} />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Activation Date</Form.Label>
                    <Form.Control type="date" value={formDataProfile.activated_on} onChange={handleChangeProfile} />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Whitelisted At</Form.Label>
                    <Form.Control type="number" value={formDataProfile.whitelistedAt} onChange={handleChangeProfile} />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Allow IPs</Form.Label>
                    <Form.Control type="text" placeholder="Enter allowed IPs"value={formDataProfile.allowed_ip} onChange={handleChangeProfile}  />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Apply Free Conversation"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Data Encryption</Form.Label>
                    <div>
                      <Form.Check
                        inline
                        type="radio"
                        name="encryption"
                        label="Yes"
                        id="encryption-yes"
                      />
                      <Form.Check
                        inline
                        type="radio"
                        name="encryption"
                        label="No"
                        id="encryption-no"
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Actions</Form.Label>
                    <div className="d-flex flex-wrap gap-3">
                      <Form.Check type="checkbox" label="Add" />
                      <Form.Check type="checkbox" label="Edit" />
                      <Form.Check type="checkbox" label="Delete" />
                      <Form.Check type="checkbox" label="Upload" />
                      <Form.Check type="checkbox" label="Email" />
                      <Form.Check type="checkbox" label="Daily Report" />
                      <Form.Check type="checkbox" label="Old Chat Logs" />
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Status</Form.Label>
                    <div>
                      <Form.Check
                        inline
                        type="radio"
                        name="status"
                        label="Active"
                        id="status-active"
                        checked={formDataProfile.status ==="Y"}
                        onChange={handleChangeProfile}
                      />
                      <Form.Check
                        inline
                        type="radio"
                        name="status"
                        label="Inactive"
                        id="status-inactive"
                        checked={formDataProfile.status !=="Y"}
                        onChange={handleChangeProfile}
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={12} className="text-end">
                  <Button variant="danger" className="me-2">
                    Cancel
                  </Button>
                  <Button variant="success" type="submit">
                    Save
                  </Button>
                </Col>
              </Row>
            </Form>
          </Tab.Pane>
          <Tab.Pane eventKey="billing">
    <Form className="profile-form" onSubmit={EditClientsCredentialCall}>
      <h5 className="mb-3">One Time Charge</h5>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Whatsapp Setup Charges</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              name="whatsapp_setup_charges"
              value={formData.whatsapp_setup_charges}
              onChange={handleChange}
              placeholder="Enter setup charges"
            />
          </Form.Group>
        </Col>
      </Row>

      <hr className="profile-divider" />

      <h5 className="mb-3">Monthly Charge</h5>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Server Charge</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              name="server_charges"
              value={formData.server_charges}
              onChange={handleChange}
              placeholder="Enter server charge"
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Monthly Recurring Charge</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              name="monthly_reccuring_charges"
              value={formData.monthly_reccuring_charges}
              onChange={handleChange}
              placeholder="Enter recurring charge"
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Other Charges</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              name="other_charges"
              value={formData.other_charges}
              onChange={handleChange}
              placeholder="Enter other charges"
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Number of Chats</Form.Label>
            <Form.Control
              type="number"
              name="number_of_chats"
              value={formData.number_of_chats}
              onChange={handleChange}
              placeholder="Enter number of chats"
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Live Chat Agent Charge</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              name="live_chat_agent_charges"
              value={formData.live_chat_charges}
              onChange={handleChange}
              placeholder="Enter agent charge"
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Submission Percentage</Form.Label>
            <Form.Control
              type="number"
              // step="0.01"
              name="submissionPercentage"
              value={formData.submissionPercentage}
              onChange={handleChange}
              placeholder="Enter agent charge"
            />
          </Form.Group>
        </Col>
      </Row>

      <hr className="profile-divider" />
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Account Type</Form.Label>
            <div>
              <Form.Check
                inline
                type="radio"
                name="accountType"
                label="Postpaid"
                id="postpaid"
                value="postpaid"
                checked={formData.account_type === "postpaid"}
                onChange={handleChange}
              />
              <Form.Check
                inline
                type="radio"
                name="accountType"
                label="Prepaid"
                id="prepaid"
                value="prepaid"
                checked={formData.account_type === "prepaid"}
                onChange={handleChange}
              />
            </div>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Receive Amount</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              name="receive_amount"
              value={formData.received_amount}
              onChange={handleChange}
              placeholder="Enter receive amount"
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Email Alert Limit</Form.Label>
            <Form.Control
              type="number"
              name="email_alert_limit"
              value={formData.email_alert_limit}
              onChange={handleChange}
              placeholder="Enter email alert limit"
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Min Balance Limit</Form.Label>
            <Form.Control
              type="number"
              name="min_balance_limit"
              value={formData.min_balance_limit}
              onChange={handleChange}
              placeholder="Enter min balance limit"
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Billing On</Form.Label>
            <div>
              <Form.Check
                inline
                type="radio"
                name="billingOn"
                label="Submission Message"
                id="submission"
                value="submission"
                checked={formData.billed_on === "submission"}
                onChange={handleChange}
              />
              <Form.Check
                inline
                type="radio"
                name="billingOn"
                label="Delivered Message"
                id="delivered"
                value="delivered"
                checked={formData.billed_on === "delivered"}
                onChange={handleChange}
              />
            </div>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>GST Number</Form.Label>
            <Form.Control
              type="text"
              name="gst_number"
              value={formData.gst_number}
              onChange={handleChange}
              placeholder="Enter GST number"
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Customer ID</Form.Label>
            <Form.Control
              type="number"
              name="customer_id"
              value={formData.customer_id}
              onChange={handleChange}
              placeholder="Enter customer ID"
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Label>Billing Type</Form.Label>
            <div>
              <Form.Check
                inline
                type="radio"
                name="billingType"
                label="Transaction Based"
                id="transaction"
                value="transaction"
                checked={formData.billing_type === "transaction"}
                onChange={handleChange}
              />
              <Form.Check
                inline
                type="radio"
                name="billingType"
                label="Conversation Based"
                id="conversation"
                value="conversation"
                checked={formData.billing_type === "conversation"}
                onChange={handleChange}
              />
            </div>
          </Form.Group>
        </Col>
      </Row>

      <hr className="profile-divider" />
      <h5 className="mb-3">PIN Charges</h5>
      <Row>
        {["marketing", "utility", "authentication", "service", "feedback", "response"].map((type) => (
          <Col md={6} key={type}>
            <Form.Group className="mb-3">
              <Form.Label>{type.charAt(0).toUpperCase() + type.slice(1)}</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                name={`${type}_pin_charges`}
                value={formData[`${type}_pin_charges`]}
                onChange={handleChange}
                placeholder={`Enter ${type} PIN charge`}
              />
            </Form.Group>
          </Col>
        ))}
      </Row>

      <Row>
        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Label>Remark</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="remark"
              value={formData.remarks}
              onChange={handleChange}
              placeholder="Enter remarks"
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={12} className="text-end">
          <Button variant="secondary" className="me-2">
            Cancel
          </Button>
          <Button variant="Success" type="submit" >
            Save
          </Button>
        </Col>
      </Row>
    </Form>
  </Tab.Pane>

          <Tab.Pane eventKey="installment">
            <Form className="profile-form">
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Installment Plan</Form.Label>
                    <Form.Select>
                      <option>3 Months</option>
                      <option>6 Months</option>
                      <option>12 Months</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Amount</Form.Label>
                    <Form.Control type="number" placeholder="Enter amount" />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Start Date</Form.Label>
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      className="form-control"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Payment Method</Form.Label>
                    <Form.Select>
                      <option>Credit Card</option>
                      <option>Debit Card</option>
                      <option>Bank Transfer</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Button variant="primary" type="submit">
                Set Up Installment
              </Button>
            </Form>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  );
};

export default ProfileSection;
